export default {
  meta: {
    title: '合同编辑',
    crumbs: [{ title: '合同', path: '/contract/purchase' }],
    // query 中存在 from=purchase 时则使用下面 purchase 面包屑
    otherCrumbs: {
      'sale': [{ title: '销售合同', path: '/contract/sale' }],
      'purchase': [{ title: '采购合同', path: '/contract/purchase' }]
    }
  }
};
